import { render } from "./PurchaseEditView.vue?vue&type=template&id=308fc224&scoped=true"
import script from "./PurchaseEditView.vue?vue&type=script&lang=js"
export * from "./PurchaseEditView.vue?vue&type=script&lang=js"

import "./PurchaseEditView.vue?vue&type=style&index=0&id=308fc224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308fc224"]])

export default __exports__